import React, { CSSProperties, forwardRef } from 'react';

import classNames from 'classnames';

import Circle from './icons/Circle.svg';

import './IntroSection.scss';

interface Props {
  leftContent?: React.ReactElement;
  rightContent: React.ReactElement;
  customClass?: string;
  style?: CSSProperties;
}

const IntroSection = forwardRef<HTMLDivElement, Props>(({ leftContent, rightContent, customClass, style }, ref) => (
  <section ref={ref} className={classNames('IntroSection_container', customClass)} style={style}>
    <div className={classNames('IntroSection_left-content')}>{leftContent}</div>
    <div className={classNames('IntroSection_right-content')}>
      <Circle />
      <div className="IntroSection_z-index-on-forward">{rightContent}</div>
    </div>
  </section>
));

export default IntroSection;
